module.exports = __webpack_public_path__ + "img/replace.33272392.png";